export default "__VITE_ASSET__e7ee4ff8__"